import AcWithdrawalDetailsDetailsTab from './details/details';

export default {
  Details: AcWithdrawalDetailsDetailsTab,
};
